import { ReactNode } from "react";
import styled from "styled-components";
import { Alert } from "@permisso/permisso-components";
import { BoldHeader1 } from "../typography/Texts";
import { FormContainer } from "src/apps/routes/onboarding/components/FormContainer";

interface ErrorLayoutProps {
  heading: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  top?: ReactNode;
  dataTestId?: string;
  noticeDataTestId?: string;
}

export const ErrorLayout = ({
  heading,
  title,
  description,
  top,
  dataTestId,
  noticeDataTestId,
}: ErrorLayoutProps) => (
  <Container data-testid={dataTestId}>
    {top}
    <BoldHeader1>{heading}</BoldHeader1>
    <Alert state="error" title={title} description={description} data-testid={noticeDataTestId} />
  </Container>
);

const Container = styled(FormContainer)`
  min-height: unset;
`;
